import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex justify-space-between align-center flex-wrap" }
const _hoisted_2 = { class: "d-flex justify-space-between align-center" }
const _hoisted_3 = { class: "text-h3 font-weight-bold stat-value-purple" }
const _hoisted_4 = { class: "d-flex justify-space-between align-center" }
const _hoisted_5 = { class: "text-h6 font-weight-bold stat-value-green" }
const _hoisted_6 = { class: "d-flex justify-space-between align-center" }
const _hoisted_7 = { class: "text-h6 font-weight-bold stat-value-blue" }
const _hoisted_8 = { class: "d-flex justify-space-between align-center" }
const _hoisted_9 = { class: "text-h6 font-weight-bold stat-value-orange" }
const _hoisted_10 = { class: "font-mono" }
const _hoisted_11 = { class: "font-weight-bold" }
const _hoisted_12 = { class: "text-green font-weight-bold" }
const _hoisted_13 = { class: "text-orange font-weight-bold" }
const _hoisted_14 = { class: "text-green font-weight-bold" }
const _hoisted_15 = { class: "d-flex gap-1" }
const _hoisted_16 = { class: "d-flex justify-space-between align-center w-100" }
const _hoisted_17 = { class: "text-h4 mb-2" }
const _hoisted_18 = { class: "text-body-1 opacity-90" }
const _hoisted_19 = { class: "text-body-1 font-weight-bold" }
const _hoisted_20 = { class: "text-body-1 font-weight-bold" }
const _hoisted_21 = { class: "text-body-1 font-weight-bold" }
const _hoisted_22 = {
  key: 0,
  class: "mb-6"
}
const _hoisted_23 = { class: "text-h6 mb-4" }
const _hoisted_24 = { class: "d-flex justify-space-between align-center mb-3" }
const _hoisted_25 = { class: "text-h6 text-purple" }
const _hoisted_26 = { class: "text-h6 font-weight-bold text-purple" }
const _hoisted_27 = { class: "text-caption font-weight-bold text-grey-darken-2 mb-1 ml-1" }
const _hoisted_28 = { class: "d-flex justify-space-between w-100" }
const _hoisted_29 = { class: "font-weight-bold" }
const _hoisted_30 = { class: "d-flex justify-space-between w-100" }
const _hoisted_31 = { class: "font-weight-bold" }
const _hoisted_32 = { class: "d-flex justify-space-between w-100" }
const _hoisted_33 = { class: "text-h6 font-weight-bold text-purple" }
const _hoisted_34 = { class: "d-flex justify-space-between w-100" }
const _hoisted_35 = { class: "font-weight-bold text-green" }
const _hoisted_36 = { class: "d-flex justify-space-between w-100" }
const _hoisted_37 = { class: "text-h6 font-weight-bold text-orange" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = {
  key: 2,
  class: "mb-6"
}
const _hoisted_41 = { class: "text-h6 mb-4" }
const _hoisted_42 = { class: "d-flex justify-space-between align-center" }
const _hoisted_43 = { class: "text-caption text-grey-darken-1" }
const _hoisted_44 = { class: "text-h6 font-weight-bold text-green" }
const _hoisted_45 = { class: "text-caption text-grey-darken-1" }
const _hoisted_46 = { class: "text-body-1" }

import { ref, onMounted, computed, onActivated } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { generatePDF as generatePDFUtil } from '@/utils/pdfGenerator'


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'cotizacionList'
},
  __name: 'cotizacionList',
  setup(__props) {



const router = useRouter()
const store = useStore()

const route = useRoute()  // agregar junto a router y store

const reloadDialog = ref(false)

const CotizacionesList = computed(() => store.state.Cotizacion.CotizacionesList)
const Cotizacion = computed(() => store.state.Cotizacion.Cotizacion)
const totalItems = computed(() => store.state.Cotizacion.totalItems)
const page = computed(() => store.state.Cotizacion.page)
const limit = computed(() => store.state.Cotizacion.limit)

const saving = ref(false)

const catalogoServicios = ref<any[]>([])
const catalogoItems = ref<any[]>([])

// Reactive state
const quotations = ref<any[]>([])
const stats = ref<any>(null)
const loading = ref(true)
const showDetail = ref(false)
const mostrarAbonos = ref(false)
const selectedQuotation = ref<any>(null)
const filters = ref({
  estado: '',
  buscarNovios: '',
  fechaDesde: '',
  fechaHasta: ''
})
const toast = ref({
  show: false,
  message: '',
  type: 'success'
})

const payments = ref([{ amount: 0 }])

// Constants
// const apiUrl = 'http://localhost:3000/api'
const estadoItems = ['Pendiente', 'Aprobada', 'Rechazada', 'Finalizada']
const headers: any[] = [
  { title: 'Número', key: 'NumeroCotizacion', align: 'start' },
  { title: 'Cliente', key: 'NombreCliente', align: 'start' },
  { title: 'Tipo Evento', key: 'TipoEvento', align: 'start' },
  { title: 'Fecha Evento', key: 'FechaEvento', align: 'start' },
  { title: 'Invitados', key: 'NumeroInvitados', align: 'center' },
  { title: 'Total', key: 'TotalConDescuento', align: 'end' },
  { title: 'Pendiente', key: 'SaldoPendiente', align: 'end' },
  { title: 'Abonado', key: 'TotalAbonosCotizacion', align: 'end' },
  { title: 'Estado', key: 'Estado', align: 'center' },
  { title: 'Estado Pago', key: 'EstadoPago', align: 'center' },
  { title: 'Acciones', key: 'actions', align: 'center', sortable: false }
]
function removePayment(index: number) {
  if (payments.value.length > 1) {
    payments.value.splice(index, 1)
  }
}
function addPayment() {
  payments.value.push({ amount: 0 })
}
async function savePayment() { 
  const cotizacionID = Cotizacion.value.data.data.cotizacion.CotizacionID
    const abonos = payments.value.map(payment => {
      if (payment.amount > 0) {
        return {
          monto: payment.amount,
          metodoPago: 'Efectivo',
          referencia: generateReference('REF'),
          observaciones: '',
        }
      }
    }).filter(item => item !== undefined)
    await store.dispatch('Cotizacion/agregarAbono', { abonos, cotizacionID })
    // showDetail.value = false
    viewDetails(cotizacionID)
    payments.value = [{ amount: 0 }]
    loadQuotations()
}
async function removeAbono(abono: any) {
  if (!confirm('¿Estás seguro de eliminar este abono?')) return
  await store.dispatch('Cotizacion/eliminarAbono', abono)
  const cotizacionID = Cotizacion.value.data.data.cotizacion.CotizacionID
  viewDetails(cotizacionID)
  loadQuotations()
}
function generateReference(prefijo: string) {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
  let reference = prefijo+'-'
  for (let i = 0; i < 10; i++) {
    reference += characters.charAt(Math.floor(Math.random() * characters.length))
  }
  return reference
}

const totalWithDiscount = computed(() => {
  return selectedQuotation.value.cotizacion.SaldoPendiente
})

const totalPaid = computed(() => {
  return payments.value.reduce((sum, p) => sum + (p.amount || 0), 0)
})

const pendingAmount = computed(() => {
  return totalWithDiscount.value - totalPaid.value
})

async function loadQuotations() {
  loading.value = true
  try {
    const params = new URLSearchParams()
    if (filters.value.estado) params.append('estado', filters.value.estado)
    if (filters.value.buscarNovios) params.append('buscarNovios', filters.value.buscarNovios)
    if (filters.value.fechaDesde) params.append('fechaDesde', filters.value.fechaDesde)
    if (filters.value.fechaHasta) params.append('fechaHasta', filters.value.fechaHasta)

    await store.dispatch('Cotizacion/fetchCotizaciones',{})

    quotations.value = CotizacionesList.value.data.data
  } catch (error) {
    console.error('Error cargando cotizaciones:', error)
    showToast('Error de conexión con el servidor', 'error')
  } finally {
    loading.value = false
  }
}

async function viewDetails(id: number, showModal = true) {
  try {
    await store.dispatch('Cotizacion/fetchObtenerCotizacion', id)
    selectedQuotation.value = Cotizacion.value.data.data
    if (showModal) {
      showDetail.value = true
    }
  } catch (error) {
    console.error('Error cargando detalles:', error)
    showToast('Error de conexión', 'error')
  }
}

async function deleteQuotation(cotizacion: any) {
  if (!confirm('¿Estás seguro de eliminar esta cotización?')) return
  
  try {
    await store.dispatch('Cotizacion/eliminarCotizacion', cotizacion)
    showToast('Cotización eliminada exitosamente')
    loadQuotations()
  } catch (error) {
    console.error('Error eliminando cotización:', error)
    showToast('Error de conexión', 'error')
  }
}

async function updateStatus(id: number, newStatus: string) {
  if (!newStatus) return
  
  try {
    showToast('Estado actualizado correctamente')
    loadQuotations()
  } catch (error) {
    console.error('Error actualizando estado:', error)
    showToast('Error de conexión', 'error')
  }
}

function clearFilters() {
  filters.value = {
    estado: '',
    buscarNovios: '',
    fechaDesde: '',
    fechaHasta: ''
  }
  loadQuotations()
}

function closeDetail() {
  showDetail.value = false
  selectedQuotation.value = null
}

function goToNew() {
  router.push('/cotizaciones/new')
}

async function getDataAndGeneratePDF(cotizacionId: number, showModal = true) {
  await viewDetails(cotizacionId, showModal)
  await generatePDF()
}

async function generatePDF() {
  saving.value = true
  try {
    if (selectedQuotation.value.cotizacion.PdfData) {
    const pdfData = JSON.parse(selectedQuotation.value.cotizacion.PdfData);
      await generatePDFUtil(pdfData)
      showToast('✅ PDF generado exitosamente')
    }else{
      showToast('No se pudo generar el PDF', 'error')
    } 
  } catch (error) {
    console.error('Error generando PDF:', error)
    showToast('Error al generar el PDF', 'error')
  } finally {
    saving.value = false
    // selectedItems.value = []
  }
}

function showToast(message: string, type = 'success') {
  toast.value = { show: true, message, type }
}

function formatCurrency(value: number) {
  return new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0
  }).format(value || 0)
}

function formatDate(dateString: string) {
  if (!dateString) return '-'
  
  // Extraer año, mes y día del string para evitar problemas de zona horaria
  const [year, month, day] = dateString.split('T')[0].split('-')
  
  // Crear fecha en zona horaria local
  const date = new Date(Number.parseInt(year), Number.parseInt(month) - 1, Number.parseInt(day))
  
  return date.toLocaleDateString('es-CO', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  })
}

function getStatusColor(estado: string) {
  const colors: Record<string, string> = {
    'Pendiente': 'warning',
    'Aprobada': 'success',
    'Rechazada': 'error',
    'Finalizada': 'info'
  }
  return colors[estado] || 'default'
}

function getPaymentColor(estadoPago: string) {
  const colors: Record<string, string> = {
    'Pagado': 'success',
    'Abonado': 'info',
    'Sin Abonos': 'error'
  }
  return colors[estadoPago] || 'default'
}

// Lifecycle
onMounted(() => {
  loadQuotations()
})

onActivated(() => {
  // Si viene desde cotizacionNew, preguntar si quiere recargar
  debugger
  if (route.query.from === 'opciones') {
    reloadDialog.value = true
    // Limpiar el query para que no vuelva a dispararse si navega entre tabs
    router.replace({ query: {} })
  }
})
function confirmReload() {
  reloadDialog.value = false
  loadQuotations()
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "quotations-container"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "header-card mb-6",
        elevation: "8"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, { class: "pa-8" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _cache[12] || (_cache[12] = _createElementVNode("div", null, [
                  _createElementVNode("h1", { class: "text-h4 text-white font-weight-bold mb-2" }, " 💍 Cotizaciones "),
                  _createElementVNode("p", { class: "text-h6 text-white opacity-90" }, " Gestión de cotizaciones - Wedding Planner ")
                ], -1)),
                _createVNode(_component_v_btn, {
                  size: "large",
                  color: "white",
                  class: "text-purple font-weight-bold mt-4 mt-md-0",
                  "prepend-icon": "mdi-plus",
                  elevation: "4",
                  onClick: goToNew
                }, {
                  default: _withCtx(() => _cache[11] || (_cache[11] = [
                    _createTextVNode(" Nueva Cotización ")
                  ])),
                  _: 1,
                  __: [11]
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (stats.value)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 0,
            class: "mb-6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "6",
                md: "3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    class: "stat-card purple-stat",
                    elevation: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_text, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", null, [
                              _cache[13] || (_cache[13] = _createElementVNode("p", { class: "text-body-2 text-grey-darken-1 mb-1" }, "Total Cotizaciones", -1)),
                              _createElementVNode("p", _hoisted_3, _toDisplayString(stats.value.totales.TotalCotizaciones || 0), 1)
                            ]),
                            _createVNode(_component_v_avatar, {
                              size: "64",
                              color: "purple-lighten-5"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  size: "40",
                                  color: "purple"
                                }, {
                                  default: _withCtx(() => _cache[14] || (_cache[14] = [
                                    _createTextVNode("mdi-clipboard-list")
                                  ])),
                                  _: 1,
                                  __: [14]
                                })
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "6",
                md: "3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    class: "stat-card green-stat",
                    elevation: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_text, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", null, [
                              _cache[15] || (_cache[15] = _createElementVNode("p", { class: "text-body-2 text-grey-darken-1 mb-1" }, "Monto Total", -1)),
                              _createElementVNode("p", _hoisted_5, _toDisplayString(formatCurrency(stats.value.totales.MontoTotal || 0)), 1)
                            ]),
                            _createVNode(_component_v_avatar, {
                              size: "64",
                              color: "green-lighten-5"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  size: "40",
                                  color: "green"
                                }, {
                                  default: _withCtx(() => _cache[16] || (_cache[16] = [
                                    _createTextVNode("mdi-cash-multiple")
                                  ])),
                                  _: 1,
                                  __: [16]
                                })
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "6",
                md: "3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    class: "stat-card blue-stat",
                    elevation: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_text, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", null, [
                              _cache[17] || (_cache[17] = _createElementVNode("p", { class: "text-body-2 text-grey-darken-1 mb-1" }, "Total Abonado", -1)),
                              _createElementVNode("p", _hoisted_7, _toDisplayString(formatCurrency(stats.value.totales.TotalAbonado || 0)), 1)
                            ]),
                            _createVNode(_component_v_avatar, {
                              size: "64",
                              color: "blue-lighten-5"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  size: "40",
                                  color: "blue"
                                }, {
                                  default: _withCtx(() => _cache[18] || (_cache[18] = [
                                    _createTextVNode("mdi-credit-card-check")
                                  ])),
                                  _: 1,
                                  __: [18]
                                })
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "6",
                md: "3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    class: "stat-card orange-stat",
                    elevation: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_text, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", null, [
                              _cache[19] || (_cache[19] = _createElementVNode("p", { class: "text-body-2 text-grey-darken-1 mb-1" }, "Pendiente", -1)),
                              _createElementVNode("p", _hoisted_9, _toDisplayString(formatCurrency(stats.value.totales.TotalPendiente || 0)), 1)
                            ]),
                            _createVNode(_component_v_avatar, {
                              size: "64",
                              color: "orange-lighten-5"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  size: "40",
                                  color: "orange"
                                }, {
                                  default: _withCtx(() => _cache[20] || (_cache[20] = [
                                    _createTextVNode("mdi-clock-alert")
                                  ])),
                                  _: 1,
                                  __: [20]
                                })
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_card, {
        class: "mb-6",
        elevation: "4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "d-flex align-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { class: "mr-2" }, {
                default: _withCtx(() => _cache[21] || (_cache[21] = [
                  _createTextVNode("mdi-filter")
                ])),
                _: 1,
                __: [21]
              }),
              _cache[22] || (_cache[22] = _createTextVNode(" Filtros "))
            ]),
            _: 1,
            __: [22]
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: filters.value.buscarNovios,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.value.buscarNovios) = $event)),
                        label: "Buscar por nombres de novios",
                        "prepend-inner-icon": "mdi-magnify",
                        variant: "outlined",
                        density: "comfortable",
                        clearable: "",
                        onKeyup: _withKeys(loadQuotations, ["enter"])
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        modelValue: filters.value.estado,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.value.estado) = $event)),
                        items: estadoItems,
                        label: "Estado",
                        "prepend-inner-icon": "mdi-format-list-bulleted",
                        variant: "outlined",
                        density: "comfortable",
                        clearable: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: filters.value.fechaDesde,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.value.fechaDesde) = $event)),
                        label: "Fecha desde",
                        type: "date",
                        variant: "outlined",
                        density: "comfortable",
                        clearable: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: filters.value.fechaHasta,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.value.fechaHasta) = $event)),
                        label: "Fecha hasta",
                        type: "date",
                        variant: "outlined",
                        density: "comfortable",
                        clearable: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "2",
                    class: "d-flex gap-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        color: "purple",
                        variant: "flat",
                        block: "",
                        onClick: loadQuotations
                      }, {
                        default: _withCtx(() => _cache[23] || (_cache[23] = [
                          _createTextVNode(" Buscar ")
                        ])),
                        _: 1,
                        __: [23]
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (loading.value)
        ? (_openBlock(), _createBlock(_component_v_card, {
            key: 1,
            class: "text-center pa-12",
            elevation: "4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_progress_circular, {
                indeterminate: "",
                color: "purple",
                size: "64",
                width: "6"
              }),
              _cache[24] || (_cache[24] = _createElementVNode("p", { class: "text-h6 mt-4" }, "Cargando cotizaciones...", -1))
            ]),
            _: 1,
            __: [24]
          }))
        : (quotations.value.length === 0)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 2,
              class: "text-center pa-12",
              elevation: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  size: "120",
                  color: "grey-lighten-1"
                }, {
                  default: _withCtx(() => _cache[25] || (_cache[25] = [
                    _createTextVNode("mdi-email-open-outline")
                  ])),
                  _: 1,
                  __: [25]
                }),
                _cache[27] || (_cache[27] = _createElementVNode("p", { class: "text-h5 mt-4 mb-2" }, "No hay cotizaciones registradas", -1)),
                _cache[28] || (_cache[28] = _createElementVNode("p", { class: "text-body-1 text-grey mb-6" }, "Comienza creando tu primera cotización", -1)),
                _createVNode(_component_v_btn, {
                  color: "purple",
                  size: "large",
                  variant: "flat",
                  "prepend-icon": "mdi-plus",
                  onClick: goToNew
                }, {
                  default: _withCtx(() => _cache[26] || (_cache[26] = [
                    _createTextVNode(" Crear Primera Cotización ")
                  ])),
                  _: 1,
                  __: [26]
                })
              ]),
              _: 1,
              __: [27,28]
            }))
          : (_openBlock(), _createBlock(_component_v_card, {
              key: 3,
              elevation: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_data_table, {
                  headers: headers,
                  items: quotations.value,
                  "items-per-page": 10,
                  class: "elevation-0"
                }, {
                  [`item.NumeroCotizacion`]: _withCtx(({ item }) => [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(item.NumeroCotizacion), 1)
                  ]),
                  [`item.NombreCliente`]: _withCtx(({ item }) => [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(item.NombreCliente), 1)
                  ]),
                  [`item.TipoEvento`]: _withCtx(({ item }) => [
                    _createElementVNode("span", null, _toDisplayString(item.TipoEvento), 1)
                  ]),
                  [`item.FechaEvento`]: _withCtx(({ item }) => [
                    _createTextVNode(_toDisplayString(formatDate(item.FechaEvento)), 1)
                  ]),
                  [`item.TotalConDescuento`]: _withCtx(({ item }) => [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(formatCurrency(item.TotalConDescuento)), 1)
                  ]),
                  [`item.SaldoPendiente`]: _withCtx(({ item }) => [
                    _createElementVNode("span", _hoisted_13, _toDisplayString(formatCurrency(item.SaldoPendiente)), 1)
                  ]),
                  [`item.TotalAbonosCotizacion`]: _withCtx(({ item }) => [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(formatCurrency(item.TotalAbonosCotizacion)), 1)
                  ]),
                  [`item.Estado`]: _withCtx(({ item }) => [
                    _createVNode(_component_v_chip, {
                      color: getStatusColor(item.Estado),
                      size: "small",
                      variant: "flat"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.Estado), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"])
                  ]),
                  [`item.EstadoPago`]: _withCtx(({ item }) => [
                    _createVNode(_component_v_chip, {
                      color: getPaymentColor(item.EstadoPago),
                      size: "small",
                      variant: "flat"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.EstadoPago), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"])
                  ]),
                  [`item.actions`]: _withCtx(({ item }) => [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_v_btn, {
                        icon: "mdi-eye",
                        size: "small",
                        color: "blue",
                        variant: "tonal",
                        onClick: ($event: any) => (viewDetails(item.CotizacionID))
                      }, null, 8, ["onClick"]),
                      _createVNode(_component_v_menu, null, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_btn, _mergeProps({
                            icon: "mdi-dots-vertical",
                            size: "small",
                            color: "purple",
                            variant: "tonal"
                          }, props), null, 16)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            icon: "mdi-file-pdf-box",
                            size: "small",
                            color: "blue",
                            variant: "flat",
                            onClick: ($event: any) => (getDataAndGeneratePDF(item.CotizacionID, false))
                          }, null, 8, ["onClick"]),
                          (item.Estado != 'Confirmada')
                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                key: 0,
                                icon: "mdi-delete",
                                size: "small",
                                color: "red",
                                variant: "flat",
                                onClick: ($event: any) => (deleteQuotation(item)),
                                disabled: item.EstadoPago == 'Abonado'
                              }, null, 8, ["onClick", "disabled"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  _: 2
                }, 1032, ["items"])
              ]),
              _: 1
            })),
      _createVNode(_component_v_dialog, {
        modelValue: showDetail.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((showDetail).value = $event)),
        "max-width": "900",
        scrollable: ""
      }, {
        default: _withCtx(() => [
          (selectedQuotation.value)
            ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "modal-header-gradient text-white pa-6" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", null, [
                          _createElementVNode("h2", _hoisted_17, _toDisplayString(selectedQuotation.value.cotizacion.NombreCliente), 1),
                          _createElementVNode("p", _hoisted_18, _toDisplayString(selectedQuotation.value.cotizacion.NumeroCotizacion), 1)
                        ]),
                        _createVNode(_component_v_btn, {
                          icon: "mdi-close",
                          variant: "text",
                          color: "white",
                          onClick: closeDetail
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, { class: "pa-6" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { class: "mb-6" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            sm: "6",
                            md: "3"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, { variant: "tonal" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card_text, null, {
                                    default: _withCtx(() => [
                                      _cache[29] || (_cache[29] = _createElementVNode("p", { class: "text-caption text-grey-darken-1 mb-1" }, "Fecha del Evento", -1)),
                                      _createElementVNode("p", _hoisted_19, _toDisplayString(formatDate(selectedQuotation.value.cotizacion.FechaEvento)), 1)
                                    ]),
                                    _: 1,
                                    __: [29]
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            sm: "6",
                            md: "3"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, { variant: "tonal" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card_text, null, {
                                    default: _withCtx(() => [
                                      _cache[30] || (_cache[30] = _createElementVNode("p", { class: "text-caption text-grey-darken-1 mb-1" }, "Invitados", -1)),
                                      _createElementVNode("p", _hoisted_20, _toDisplayString(selectedQuotation.value.cotizacion.NumeroInvitados), 1)
                                    ]),
                                    _: 1,
                                    __: [30]
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            sm: "6",
                            md: "3"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, { variant: "tonal" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card_text, null, {
                                    default: _withCtx(() => [
                                      _cache[31] || (_cache[31] = _createElementVNode("p", { class: "text-caption text-grey-darken-1 mb-1" }, "Estado", -1)),
                                      _createVNode(_component_v_chip, {
                                        color: getStatusColor(selectedQuotation.value.cotizacion.Estado),
                                        size: "small",
                                        variant: "flat"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(selectedQuotation.value.cotizacion.Estado), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["color"])
                                    ]),
                                    _: 1,
                                    __: [31]
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            sm: "6",
                            md: "3"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, { variant: "tonal" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card_text, null, {
                                    default: _withCtx(() => [
                                      _cache[32] || (_cache[32] = _createElementVNode("p", { class: "text-caption text-grey-darken-1 mb-1" }, "Fecha de Creación", -1)),
                                      _createElementVNode("p", _hoisted_21, _toDisplayString(formatDate(selectedQuotation.value.cotizacion.FechaCreacion)), 1)
                                    ]),
                                    _: 1,
                                    __: [32]
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (selectedQuotation.value.servicios)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _createElementVNode("h3", _hoisted_23, [
                              _createVNode(_component_v_icon, { class: "mr-2" }, {
                                default: _withCtx(() => _cache[33] || (_cache[33] = [
                                  _createTextVNode("mdi-clipboard-list")
                                ])),
                                _: 1,
                                __: [33]
                              }),
                              _cache[34] || (_cache[34] = _createTextVNode(" Servicios Contratados: "))
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedQuotation.value.servicios, (service, idx) => {
                              return (_openBlock(), _createBlock(_component_v_card, {
                                key: idx,
                                class: "mb-3",
                                variant: "outlined",
                                border: "start",
                                color: "purple"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card_text, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_24, [
                                        _createElementVNode("h4", _hoisted_25, _toDisplayString(service.NombreServicio), 1),
                                        _createElementVNode("span", _hoisted_26, _toDisplayString(formatCurrency(service.Precio)), 1)
                                      ]),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(service.secciones, (seccion) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: seccion.NombreSeccion,
                                          class: "mb-2"
                                        }, [
                                          _createElementVNode("p", _hoisted_27, _toDisplayString(seccion.NombreSeccion), 1),
                                          _createVNode(_component_v_list, {
                                            density: "compact",
                                            class: "bg-transparent"
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(seccion.items, (item, i) => {
                                                return (_openBlock(), _createBlock(_component_v_list_item, {
                                                  key: i,
                                                  class: "px-0"
                                                }, {
                                                  prepend: _withCtx(() => [
                                                    _createVNode(_component_v_icon, {
                                                      size: "small",
                                                      color: "purple"
                                                    }, {
                                                      default: _withCtx(() => _cache[35] || (_cache[35] = [
                                                        _createTextVNode("mdi-circle-small")
                                                      ])),
                                                      _: 1,
                                                      __: [35]
                                                    })
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _createTextVNode(" " + _toDisplayString(item), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_card, {
                        variant: "tonal",
                        class: "mb-6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_title, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, { class: "mr-2" }, {
                                default: _withCtx(() => _cache[36] || (_cache[36] = [
                                  _createTextVNode("mdi-calculator")
                                ])),
                                _: 1,
                                __: [36]
                              }),
                              _cache[37] || (_cache[37] = _createTextVNode(" Resumen Financiero "))
                            ]),
                            _: 1,
                            __: [37]
                          }),
                          _createVNode(_component_v_card_text, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list, {
                                density: "compact",
                                class: "bg-transparent"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_28, [
                                        _cache[38] || (_cache[38] = _createElementVNode("span", null, "Subtotal:", -1)),
                                        _createElementVNode("span", _hoisted_29, _toDisplayString(formatCurrency(selectedQuotation.value.cotizacion.Subtotal)), 1)
                                      ])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item, { class: "text-red" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_30, [
                                        _createElementVNode("span", null, "Descuento (" + _toDisplayString(selectedQuotation.value.cotizacion.PorcentajeDescuento) + "%):", 1),
                                        _createElementVNode("span", _hoisted_31, " -" + _toDisplayString(formatCurrency(selectedQuotation.value.cotizacion.MontoDescuento)), 1)
                                      ])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_divider, { class: "my-2" }),
                                  _createVNode(_component_v_list_item, { class: "bg-purple-lighten-5" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_32, [
                                        _cache[39] || (_cache[39] = _createElementVNode("span", { class: "text-h6 font-weight-bold" }, "Total:", -1)),
                                        _createElementVNode("span", _hoisted_33, _toDisplayString(formatCurrency(selectedQuotation.value.cotizacion.TotalConDescuento)), 1)
                                      ])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item, { class: "bg-green-lighten-5" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_34, [
                                        _cache[40] || (_cache[40] = _createElementVNode("span", { class: "font-weight-bold" }, "Abonado:", -1)),
                                        _createElementVNode("span", _hoisted_35, _toDisplayString(formatCurrency(selectedQuotation.value.cotizacion.TotalAbonosCotizacion)), 1)
                                      ])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item, { class: "bg-orange-lighten-5" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_36, [
                                        _cache[41] || (_cache[41] = _createElementVNode("span", { class: "text-h6 font-weight-bold" }, "Pendiente:", -1)),
                                        _createElementVNode("span", _hoisted_37, _toDisplayString(formatCurrency(selectedQuotation.value.cotizacion.SaldoPendiente)), 1)
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_btn, {
                        size: "large",
                        color: "purple",
                        block: "",
                        variant: "tonal",
                        title: "Realizar un Abono",
                        class: "mt-4 mb-4",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (mostrarAbonos.value = !mostrarAbonos.value)),
                        disabled: selectedQuotation.value.cotizacion.SaldoPendiente <= 0
                      }, {
                        default: _withCtx(() => [
                          (mostrarAbonos.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_38, [
                                _createVNode(_component_v_icon, { start: "" }, {
                                  default: _withCtx(() => _cache[42] || (_cache[42] = [
                                    _createTextVNode("mdi-chevron-up")
                                  ])),
                                  _: 1,
                                  __: [42]
                                }),
                                _cache[43] || (_cache[43] = _createTextVNode(" Ocultar Abonos"))
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_39, [
                                _createVNode(_component_v_icon, { start: "" }, {
                                  default: _withCtx(() => _cache[44] || (_cache[44] = [
                                    _createTextVNode("mdi-chevron-down")
                                  ])),
                                  _: 1,
                                  __: [44]
                                }),
                                _cache[45] || (_cache[45] = _createTextVNode(" Agregar Abono"))
                              ]))
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      (mostrarAbonos.value && selectedQuotation.value.cotizacion.SaldoPendiente > 0)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 1,
                            cols: "12",
                            md: "12"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, {
                                variant: "outlined",
                                class: "bg-grey-lighten-5"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card_title, { class: "text-subtitle-1 pa-4" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, { start: "" }, {
                                        default: _withCtx(() => _cache[46] || (_cache[46] = [
                                          _createTextVNode("mdi-cash-check")
                                        ])),
                                        _: 1,
                                        __: [46]
                                      }),
                                      _cache[47] || (_cache[47] = _createTextVNode(" Abonos "))
                                    ]),
                                    _: 1,
                                    __: [47]
                                  }),
                                  _createVNode(_component_v_card_text, null, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(payments.value, (payment, idx) => {
                                        return (_openBlock(), _createBlock(_component_v_row, {
                                          key: idx,
                                          dense: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, { cols: "9" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_text_field, {
                                                  modelValue: payment.amount,
                                                  "onUpdate:modelValue": ($event: any) => ((payment.amount) = $event),
                                                  modelModifiers: { number: true },
                                                  label: "Monto del abono",
                                                  type: "number",
                                                  prefix: "$",
                                                  variant: "outlined",
                                                  density: "compact",
                                                  max: pendingAmount.value,
                                                  "hide-details": ""
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "max"])
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_v_col, { cols: "3" }, {
                                              default: _withCtx(() => [
                                                (payments.value.length > 1)
                                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                                      key: 0,
                                                      icon: "",
                                                      color: "error",
                                                      variant: "text",
                                                      onClick: ($event: any) => (removePayment(idx))
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_icon, null, {
                                                          default: _withCtx(() => _cache[48] || (_cache[48] = [
                                                            _createTextVNode("mdi-close")
                                                          ])),
                                                          _: 1,
                                                          __: [48]
                                                        })
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["onClick"]))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128)),
                                      _createVNode(_component_v_btn, {
                                        block: "",
                                        color: "primary",
                                        variant: "outlined",
                                        "prepend-icon": "mdi-plus",
                                        class: "mt-3",
                                        onClick: addPayment
                                      }, {
                                        default: _withCtx(() => _cache[49] || (_cache[49] = [
                                          _createTextVNode(" Otro Abono ")
                                        ])),
                                        _: 1,
                                        __: [49]
                                      }),
                                      _createVNode(_component_v_divider, { class: "my-4" }),
                                      _createVNode(_component_v_list_item, { class: "bg-warning-lighten-4 rounded" }, {
                                        prepend: _withCtx(() => [
                                          _createVNode(_component_v_icon, { color: "warning" }, {
                                            default: _withCtx(() => _cache[50] || (_cache[50] = [
                                              _createTextVNode("mdi-alert-circle")
                                            ])),
                                            _: 1,
                                            __: [50]
                                          })
                                        ]),
                                        append: _withCtx(() => [
                                          _createElementVNode("span", {
                                            class: _normalizeClass(["font-weight-bold text-h6", pendingAmount.value < 0 ? 'stat-value-red' : 'text-warning'])
                                          }, _toDisplayString(formatCurrency(pendingAmount.value)), 3)
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_list_item_title, { class: "font-weight-bold" }, {
                                            default: _withCtx(() => _cache[51] || (_cache[51] = [
                                              _createTextVNode("Pendiente :")
                                            ])),
                                            _: 1,
                                            __: [51]
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_btn, {
                                        block: "",
                                        color: "primary",
                                        variant: "flat",
                                        "prepend-icon": "mdi-cash-check",
                                        class: "mt-3",
                                        disabled: pendingAmount.value < 0,
                                        onClick: savePayment
                                      }, {
                                        default: _withCtx(() => _cache[52] || (_cache[52] = [
                                          _createTextVNode(" Realizar Abono ")
                                        ])),
                                        _: 1,
                                        __: [52]
                                      }, 8, ["disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (selectedQuotation.value.abonos?.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                            _createElementVNode("h3", _hoisted_41, [
                              _createVNode(_component_v_icon, { class: "mr-2" }, {
                                default: _withCtx(() => _cache[53] || (_cache[53] = [
                                  _createTextVNode("mdi-credit-card")
                                ])),
                                _: 1,
                                __: [53]
                              }),
                              _cache[54] || (_cache[54] = _createTextVNode(" Abonos Registrados "))
                            ]),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedQuotation.value.abonos, (abono, idx) => {
                                  return (_openBlock(), _createBlock(_component_v_col, {
                                    key: idx,
                                    cols: "12",
                                    sm: "6",
                                    md: "4"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_card, {
                                        variant: "outlined",
                                        border: "start",
                                        color: "green"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_card_text, null, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_42, [
                                                _createElementVNode("div", null, [
                                                  _createElementVNode("p", _hoisted_43, " Abono " + _toDisplayString(abono.NumeroAbono), 1),
                                                  _createElementVNode("p", _hoisted_44, _toDisplayString(formatCurrency(abono.Monto)), 1),
                                                  _createElementVNode("p", _hoisted_45, _toDisplayString(formatDate(abono.FechaAbono)), 1)
                                                ]),
                                                _createVNode(_component_v_icon, {
                                                  size: "40",
                                                  color: "green-lighten-1"
                                                }, {
                                                  default: _withCtx(() => _cache[55] || (_cache[55] = [
                                                    _createTextVNode(" mdi-check-circle ")
                                                  ])),
                                                  _: 1,
                                                  __: [55]
                                                }),
                                                (pendingAmount.value > 0)
                                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                                      key: 0,
                                                      icon: "",
                                                      color: "error",
                                                      variant: "text",
                                                      disabled: idx !== selectedQuotation.value.abonos.length - 1,
                                                      onClick: ($event: any) => (removeAbono(abono))
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_icon, null, {
                                                          default: _withCtx(() => _cache[56] || (_cache[56] = [
                                                            _createTextVNode("mdi-trash-can-outline")
                                                          ])),
                                                          _: 1,
                                                          __: [56]
                                                        })
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["disabled", "onClick"]))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (selectedQuotation.value.cotizacion.Observaciones)
                        ? (_openBlock(), _createBlock(_component_v_card, {
                            key: 3,
                            variant: "outlined",
                            border: "start",
                            color: "orange"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card_title, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, { class: "mr-2" }, {
                                    default: _withCtx(() => _cache[57] || (_cache[57] = [
                                      _createTextVNode("mdi-note-text")
                                    ])),
                                    _: 1,
                                    __: [57]
                                  }),
                                  _cache[58] || (_cache[58] = _createTextVNode(" Observaciones "))
                                ]),
                                _: 1,
                                __: [58]
                              }),
                              _createVNode(_component_v_card_text, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("p", _hoisted_46, _toDisplayString(selectedQuotation.value.cotizacion.Observaciones), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_actions, { class: "pa-4" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        color: "primary",
                        variant: "flat",
                        "prepend-icon": "mdi-file-pdf-box",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (getDataAndGeneratePDF(selectedQuotation.value.cotizacion.CotizacionID, true)))
                      }, {
                        default: _withCtx(() => _cache[59] || (_cache[59] = [
                          _createTextVNode(" Generar PDF ")
                        ])),
                        _: 1,
                        __: [59]
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_snackbar, {
        modelValue: toast.value.show,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((toast.value.show) = $event)),
        color: toast.value.type === 'success' ? 'green' : 'red',
        timeout: 3000,
        location: "top right"
      }, {
        actions: _withCtx(() => [
          _createVNode(_component_v_btn, {
            variant: "text",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (toast.value.show = false))
          }, {
            default: _withCtx(() => _cache[60] || (_cache[60] = [
              _createTextVNode(" Cerrar ")
            ])),
            _: 1,
            __: [60]
          })
        ]),
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(toast.value.message) + " ", 1)
        ]),
        _: 1
      }, 8, ["modelValue", "color"]),
      _createVNode(_component_v_dialog, {
        modelValue: reloadDialog.value,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((reloadDialog).value = $event)),
        "max-width": "420",
        persistent: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "text-h6 pt-5 px-6" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    color: "primary",
                    class: "mr-2"
                  }, {
                    default: _withCtx(() => _cache[61] || (_cache[61] = [
                      _createTextVNode("mdi-refresh")
                    ])),
                    _: 1,
                    __: [61]
                  }),
                  _cache[62] || (_cache[62] = _createTextVNode(" Actualizar cotizaciones "))
                ]),
                _: 1,
                __: [62]
              }),
              _createVNode(_component_v_card_text, { class: "px-6" }, {
                default: _withCtx(() => _cache[63] || (_cache[63] = [
                  _createTextVNode(" Acabas de crear una nueva cotización. ¿Deseas recargar la lista para ver las cotizaciones actualizadas? ")
                ])),
                _: 1,
                __: [63]
              }),
              _createVNode(_component_v_card_actions, { class: "pa-4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (reloadDialog.value = false))
                  }, {
                    default: _withCtx(() => _cache[64] || (_cache[64] = [
                      _createTextVNode("No, mantener")
                    ])),
                    _: 1,
                    __: [64]
                  }),
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    variant: "elevated",
                    onClick: confirmReload
                  }, {
                    default: _withCtx(() => _cache[65] || (_cache[65] = [
                      _createTextVNode("Sí, actualizar")
                    ])),
                    _: 1,
                    __: [65]
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})